import React, { useState } from "react";
import { Link } from "react-router-dom";
import { logout } from "../../actions/userActions";
import { useDispatch } from "react-redux";

export default function NavBar() {
  const dispatch = useDispatch();
  const [activePage, setActivePage] = useState("Home");
  const logoutHandler = () => {
    if (window.confirm("Do you want logout")) {
      dispatch(logout());
    }
  };
  return (
    <nav class="navbar col-lg-12 col-12 p-0 fixed-top d-flex flex-row">
      <div class="text-center navbar-brand-wrapper d-flex align-items-center justify-content-center">
        <a class="navbar-brand brand-logo mr-5" href="/">
          {/* <img src="images/logo.svg" class="mr-2" alt="logooo" /> */}
          Adcaster
        </a>
        <a class="navbar-brand brand-logo-mini" href="/">
          {/* <img src="images/logo-mini.svg" alt="logo" />asas */}
          <span style={{ fontSize: "16px" }}>Adcaster</span>
        </a>
      </div>
      <div class="navbar-menu-wrapper d-flex align-items-center justify-content-end">
        <button
          class="navbar-toggler navbar-toggler align-self-center"
          type="button"
          data-toggle="minimize"
        >
          <span class="icon-menu"></span>
        </button>
        <ul class="navbar-nav mr-lg-2">
          <li class="nav-item nav-search d-none d-lg-block">
            <div class="input-group">
              <div
                class="input-group-prepend hover-cursor"
                id="navbar-search-icon"
              >
                {/* <span class="input-group-text" id="search">
                  <i class="icon-search"></i>
                </span> */}
              </div>
              {/* <input
                type="text"
                class="form-control"
                id="navbar-search-input"
                placeholder="Search now"
                aria-label="search"
                aria-describedby="search"
              /> */}
            </div>
          </li>
        </ul>
        <ul class="navbar-nav navbar-nav-right">
          <li class="nav-item dropdown">
            <a
              class="nav-link count-indicator dropdown-toggle"
              // id="notificationDropdown"
              href="#"
              data-toggle="dropdown"
            >
              <i className="ti-menu"></i>
            </a>
            <div
              class="dropdown-menu dropdown-menu-right navbar-dropdown preview-list"
              aria-labelledby="notificationDropdown"
            >
              <ul>
                <li
                  class={activePage === "Home" ? `nav-item active` : "nav-item"}
                  onClick={() => setActivePage("Home")}
                >
                  <Link class="nav-link" to="/">
                    <i class="icon-grid menu-icon"></i>
                    <span class="menu-title">Dashboard</span>
                  </Link>
                </li>
                <li
                  class={
                    activePage === "pending" ? `nav-item active` : "nav-item"
                  }
                  onClick={() => setActivePage("pending")}
                >
                  <Link class="nav-link" to="/pending/view">
                    <i class="icon-grid menu-icon"></i>
                    <span class="menu-title">Pending</span>
                  </Link>
                </li>
                <li
                  class={
                    activePage === "order-cancellations"
                      ? `nav-item active`
                      : "nav-item"
                  }
                  onClick={() => setActivePage("pending")}
                >
                  <Link class="nav-link" to="/order-cancellations">
                    <i class="icon-grid menu-icon"></i>
                    <span class="menu-title">Order Cancel</span>
                  </Link>
                </li>
                <li
                  class={
                    activePage === "orderApprovals"
                      ? `nav-item active`
                      : "nav-item"
                  }
                  onClick={() => setActivePage("orderApprovals")}
                >
                  <Link
                    class="nav-link"
                    to="/order-approvals"
                    aria-expanded="false"
                  >
                    <i class="icon-layout menu-icon"></i>
                    <span class="menu-title">Order Approvals</span>
                  </Link>
                </li>
                <li
                  class={
                    activePage === "package" ? `nav-item active` : "nav-item"
                  }
                  onClick={() => setActivePage("package")}
                >
                  <Link class="nav-link" to="/package/view">
                    <i class="icon-grid menu-icon"></i>
                    <span class="menu-title">Package</span>
                  </Link>
                </li>
                <li
                  class={
                    activePage === "category" ? `nav-item active` : "nav-item"
                  }
                  onClick={() => setActivePage("category")}
                >
                  <Link
                    class="nav-link"
                    data-toggle="collapse"
                    to="/categories"
                    aria-expanded="false"
                    aria-controls="ui-basic"
                  >
                    <i class="icon-layout menu-icon"></i>
                    <span class="menu-title">Category</span>
                  </Link>
                </li>
                <li
                  class={
                    activePage === "brand" ? `nav-item active` : "nav-item"
                  }
                  onClick={() => setActivePage("brand")}
                >
                  <Link
                    class="nav-link"
                    data-toggle="collapse"
                    to="/brands"
                    aria-expanded="false"
                    aria-controls="ui-basic"
                  >
                    <i class="icon-layout menu-icon"></i>
                    <span class="menu-title">Brands</span>
                  </Link>
                </li>

                <li
                  class={activePage === "user" ? `nav-item active` : "nav-item"}
                  onClick={() => setActivePage("user")}
                >
                  <Link
                    class="nav-link"
                    data-toggle="collapse"
                    to="/users"
                    aria-expanded="false"
                    aria-controls="ui-basic"
                  >
                    <i class="icon-grid-2 menu-icon"></i>
                    <span class="menu-title">Customer</span>
                  </Link>
                </li>

                <li
                  class={
                    activePage === "orders" ? `nav-item active` : "nav-item"
                  }
                  onClick={() => setActivePage("orders")}
                >
                  <Link
                    class="nav-link"
                    data-toggle="collapse"
                    to="/orders"
                    aria-expanded="false"
                    aria-controls="ui-basic"
                  >
                    <i class="icon-layout menu-icon"></i>
                    <span class="menu-title">Orders</span>
                  </Link>
                </li>
                <li
                  class={
                    activePage === "new-order" ? `nav-item active` : "nav-item"
                  }
                  onClick={() => setActivePage("new-order")}
                >
                  <Link
                    class="nav-link"
                    data-toggle="collapse"
                    to="/order/new"
                    aria-expanded="false"
                    aria-controls="ui-basic"
                  >
                    <i class="icon-contract menu-icon"></i>
                    <span class="menu-title">New Orders</span>
                  </Link>
                </li>

                <li
                  class={
                    activePage === "availability"
                      ? `nav-item active`
                      : "nav-item"
                  }
                  onClick={() => setActivePage("availability")}
                >
                  <Link
                    class="nav-link"
                    data-toggle="collapse"
                    to="/order/search"
                    aria-expanded="false"
                    aria-controls="ui-basic"
                  >
                    <i class="icon-contract menu-icon"></i>
                    <span class="menu-title">Availability</span>
                  </Link>
                </li>

                <li
                  class={
                    activePage === "product" ? `nav-item active` : "nav-item"
                  }
                  onClick={() => setActivePage("product")}
                >
                  <Link
                    class="nav-link"
                    data-toggle="collapse"
                    to="/products"
                    aria-expanded="false"
                    aria-controls="ui-basic"
                  >
                    <i class="icon-grid-2 menu-icon"></i>
                    <span class="menu-title">Product</span>
                  </Link>
                </li>

                <li
                  class={
                    activePage === "not-delivered-list"
                      ? `nav-item active`
                      : "nav-item"
                  }
                  onClick={() => setActivePage("not-delivered-list")}
                >
                  <Link
                    class="nav-link"
                    data-toggle="collapse"
                    to="/not-delivery"
                    aria-expanded="false"
                    aria-controls="charts"
                  >
                    <i class="icon-bar-graph menu-icon"></i>
                    <span class="menu-title">Rent out Pending</span>
                  </Link>{" "}
                </li>
                <li
                  class={
                    activePage === "not-return-list"
                      ? `nav-item active`
                      : "nav-item"
                  }
                  onClick={() => setActivePage("not-return-list")}
                >
                  <Link
                    class="nav-link"
                    data-toggle="collapse"
                    to="/not-return"
                    aria-expanded="false"
                    aria-controls="charts"
                  >
                    <i class="icon-bar-graph menu-icon"></i>
                    <span class="menu-title">Return Pending</span>
                  </Link>{" "}
                </li>
                <li
                  class={
                    activePage === "receive" ? `nav-item active` : "nav-item"
                  }
                  onClick={() => setActivePage("receive")}
                  data-toggle="modal"
                  data-target="#exampleModal"
                >
                  <Link
                    class="nav-link"
                    data-toggle="collapse"
                    aria-expanded="false"
                    aria-controls="charts"
                  >
                    <i class="icon-contract menu-icon"></i>
                    <span class="menu-title">Receive</span>
                  </Link>
                </li>

                <li
                  class={
                    activePage === "rent-out" ? `nav-item active` : "nav-item"
                  }
                  onClick={() => setActivePage("rent-out")}
                >
                  <Link
                    class="nav-link"
                    data-toggle="collapse"
                    to="/rent-out"
                    aria-expanded="false"
                    aria-controls="charts"
                  >
                    <i class="icon-bar-graph menu-icon"></i>
                    <span class="menu-title">Rent Out</span>
                  </Link>{" "}
                </li>

                <li
                  class={
                    activePage === "return" ? `nav-item active` : "nav-item"
                  }
                >
                  <Link
                    class="nav-link"
                    data-toggle="collapse"
                    aria-expanded="false"
                    aria-controls="charts"
                    to="/return"
                  >
                    <i class="icon-contract menu-icon"></i>
                    <span class="menu-title">Return</span>
                  </Link>{" "}
                </li>
                <li
                  class={
                    activePage === "report" ? `nav-item active` : "nav-item"
                  }
                  onClick={() => setActivePage("report")}
                >
                  <Link class="nav-link" to="/report" aria-expanded="false">
                    <i class="icon-bar-graph menu-icon"></i>
                    <span class="menu-title">Report</span>
                  </Link>
                </li>
              </ul>
            </div>
          </li>

          <li class="nav-item dropdown">
            <a
              class="nav-link count-indicator dropdown-toggle"
              id="notificationDropdown"
              href="#"
              data-toggle="dropdown"
            >
              <i class="icon-bell mx-0"></i>
              <span class="count"></span>
            </a>
            <div
              class="dropdown-menu dropdown-menu-right navbar-dropdown preview-list"
              aria-labelledby="notificationDropdown"
            >
              <p class="mb-0 font-weight-normal float-left dropdown-header">
                Notifications
              </p>
              <Link class="dropdown-item preview-item" to="/user/pending">
                <div class="preview-thumbnail">
                  <div class="preview-icon bg-warning">
                    <i class="ti-info-alt mx-0"></i>
                  </div>
                </div>
                <div class="preview-item-content">
                  <h6 class="preview-subject font-weight-normal">
                    Pending Customers
                  </h6>
                  <p class="font-weight-light small-text mb-0 text-muted">
                    latest
                  </p>
                </div>
              </Link>
            </div>
          </li>
          <li class="nav-item nav-profile dropdown">
            <a
              class="nav-link dropdown-toggle"
              href="#"
              data-toggle="dropdown"
              id="profileDropdown"
            >
              <img
                src={process.env.PUBLIC_URL + "images/user.png"}
                alt="profile"
                height="5px"
                width="5px"
                style={{ width: "50px" }}
              />
            </a>
            <div
              class="dropdown-menu dropdown-menu-right navbar-dropdown"
              aria-labelledby="profileDropdown"
            >
              {/* <a class="dropdown-item">
                <i class="ti-settings text-primary"></i>
                Settings
              </a> */}
              <a class="dropdown-item">
                <Link class="nav-link" onClick={logoutHandler} to="">
                  <i class="ti-power-off text-primary"></i>
                  <span class="menu-title">Logout</span>
                </Link>
              </a>
            </div>
          </li>
        </ul>

        <button
          class="navbar-toggler navbar-toggler-right d-lg-none align-self-center"
          type="button"
          data-toggle="offcanvas"
        >
          <span class="icon-menu"></span>
        </button>
      </div>
    </nav>
  );
}
